export default {
    // 模块名称
    linkage: {
      // 按钮类
      button: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        add: 'Add'
      },
      // 文字标签类
      label: {
        addDevice: 'Add device'
      }
    },
    task: {
      status: {
        CREATED: '已创建',
        PENDING_CREATE: '等待中',
        SCHEDULING: '调度中',
        CREATE_FAIL: '创建失败',
        PENDING_TERMINATED: '终止中',
        TERMINATED: '已终止',
        STARTING: '启动中',
        RUNNING: '运行中',
        SUCCEEDED: '运行成功',
        FAILED: '运行失败',
        PENDING_DELETE: '删除中',
        DELETE_FAIL: '删除失败',
        ABNORMAL: '运行异常',
      }
    }
  }
  